export default {
  initialValue: 'حد پایین',
  percentageValue(percentage: string) {
    return `٪ ${percentage}`;
  },
  targetFunc(target: string) {
    return `هدف: ${target} `;
  },
  target: 'هدف',
  untilDate(date: string) {
    return `تا ${date}`;
  },
  withoutData: '---',
  average: 'میانگین',
  totalRealization: 'میانگین درصد تحقق',
  totalRealizationBound: 'میانگین درصد تحقق محدود شده',
  totalRealizationBoundInfo:
    'مقادیر بیشتر از ۱۰۰ به ۱۰۰ و کمتر از ۰ به ۰ تبدیل می‌شوند.',
};
